import { holdingArea } from './holdingArea';
import { medias } from './../Global/medias.js';

class HoldingAreaAssessorSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('11');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() +
        this.app.$t(' - ') +
        this.app.$t('Holding Area') +
        this.app.$t(' assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper(
      'Holding Area',
      tableOfContentsCalculatorPosition,
      this.group,
    );

    holdingArea(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '11', this.user);
  }
}

export default HoldingAreaAssessorSlides;
